module.exports = false;


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/babel-polyfill/~/core-js/modules/_library.js
// module id = 27
// module chunks = 0